import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../api/ApiSettings";


export const getComplaintPositionComponents = createAsyncThunk('complaintPositionComponents/getComplaintPositionComponents', async () => {
    const response = await fetch(`${API_URL}complaintPositionComponents/getComplaintPositionComponents`);
    const data = await response.json(); 
    return data;
  });

export const complaintPositionComponentSlice = createSlice({
    name: 'complaintPositionComponents',
    initialState:{
        complaintPositionComponents:[]
    },
    reducers:{},
    extraReducers: {
        [getComplaintPositionComponents.fulfilled]: (state, action) =>{
            state.complaintPositionComponents = action.payload;
        }
      }
});

export const {setComplaintPositionComponents} = complaintPositionComponentSlice.actions
export default complaintPositionComponentSlice.reducer;